import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    driver: -1,
    schema: {
      ride_time: [],
      colors: [],
      transportation_platform: [],
      car_types: [],
      categories: []
    },
    keys: {},
    token: {},
    user: {},
    fund: 0,
    stripeConnection: false,
    activeLink: '',
    menu: false,
    popup: false
  },
  plugins: [createPersistedState({
    paths: ['driver', 'user', 'schema', 'token', 'fund', 'stripeConnection']
  })],
  mutations: {
    setToken (state, data) {
      console.log('Data in store', data)
      state.token = {
        token: data.token,
        refresh_token: data.refresh_token,
        expires: data.expires,
        JWT: data.JWT,
        redirect: data.redirect || false
      }
    },
    setDriver (state, driver) {
      state.driver = driver
    },
    setUser (state, user) {
      state.user = user
    },
    setSchema (state, schema) {
      state.schema = schema
    },
    setFunds (state, fund) {
      state.fund = fund
    },
    setActiveLink (state, link) {
      state.activeLink = link
    },
    // setRedirect (state, redirect) {
    //   state.redirect = redirect
    // },
    logout (state) {
      state.token = null
    },
    setMenu (state, menu) {
      state.menu = menu
    },
    setPopup (state, popup) {
      state.popup = popup
    },
    setStripeConnection (state, flag) {
      state.stripeConnection = flag
    },
    setKeys(state, keys) {
      state.keys = keys
    }
  },
  getters: {
    getToken: state => {
      return state.token
    },
    getSchema: state => {
      return state.schema
    },
    getRole: state => {
      return state.role
    },
    getUser: state => {
      return state.user
    },
    getFund: state => {
      return state.fund
    },
    getActiveLink: state => {
      return state.activeLink
    },
    getMenu: state => {
      return state.menu
    },
    getPopup: state => {
      return state.popup
    },
    keys: state => state.keys,
    stripeConnection: state => {
      return state.stripeConnection
    }
  },
  actions: {
    setToken (context) {
      context.commit('setToken')
    },
    setDriver (context) {
      context.commit('setDriver')
    },
    setUser (context) {
      context.commit('setUser')
    },
    setSchema (context) {
      context.commit('setSchema')
    },
    setFunds (context) {
      context.commit('setFunds')
    },
    setActiveLink (context) {
      context.commit('setActiveLink')
    },
    logout (context) {
      context.commit('logout')
    },
    setMenu (context) {
      context.commit('setMenu')
    },
    setPopup (context) {
      context.commit('setPopup')
    },
    setStripeConnection (context) {
      context.commit('setStripeConnection')
    }
  }
})
